import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle"; 
import abcProcureImg from "../../Assets/abc_procure_logo.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={abcProcureImg}
              isBlog={false}
              title="ABC Procure"
              description="ABC Procure is a large-scale enterprise e-Procurement platform for managing tenders, auctions, RFQs, contracts, payments, and workflow automation. Built using Java, Spring MVC, Hibernate, JSP, and SQL Server, I contributed to backend development, production support, digital signature integration, and CSP migration for a legacy enterprise application."
              ghLink="https://github.com/akul09"
            />
          </Col>

            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://jambo.in/assets/images/website/hero/intro.svg"}
              isBlog={false}
              title="Jambo"
              description="Jambo is a community and association management platform that enables organizations to create and manage memberships, events, subscriptions, and communication. Built with Java, Spring Boot, React, Angular, MySQL, and REST APIs, I developed backend services, payment integrations, and features to improve user engagement and platform scalability."
              ghLink="https://github.com/akul09"
               
            />
          </Col>
            

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://img.freepik.com/free-photo/stethoscope-blue-background_23-2147612257.jpg?t=st=1716539463~exp=1716543063~hmac=143d9e691d4b3bc64b3439b39769e48800e26b3dde0748cb7843ad93aa89da0d&w=996"}
              isBlog={false}
              title="UpcharDwar(Virtual Clinic)"
              description="UpcharDwar is a virtual healthcare platform that enables patients to consult doctors online, manage appointments, access digital prescriptions, and monitor health records. Built using Angular, Java, Spring Boot, and MySQL, it focuses on providing a secure, responsive, and user-friendly experience for healthcare services."
              ghLink="https://github.com/akul09/Upchardwar_Angular.git"
 
            />
          </Col>

      
        
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
